module.exports = __webpack_public_path__ + "static/media/dropbox.b53eaec4.svg";